import "../../styles/product-detail.css";
import Footer from "../../components/footer";
import Header from "../../components/header";

function IVisitNg() {
  return (
    <div>
      <Header />
      <div className="product-details">
        <div className="details-heading">
          <h1>iVisitNG</h1>
          <p>Developed by our team of professionals.</p>
        </div>
        <div className="details-body">
          <p>
            <span>iVisitNG</span>, a fully customizable web based integrated
            biometric visitors' management and access control solution with
            functionalities that will allow for pre-registration of individual
            or group of visitors by authorized employee at all levels.
          </p>
          <p>
            <span>iVisitNG</span> is used for visitor registration, chip-based
            badge printing, tracking, reporting, visitors' preregistration and
            employee/contractor time and attendance management system. It is
            used for access control to prevent access to unauthorized offices
            and be extended to asset tracking. It is scalable and user friendly
            and needs little or NO training. It comes with a rule based approach
            in case further approvals are required for certain visitors.
          </p>
          <p>
            It can quickly scale to a network of hundreds of workstations, all
            running on a centralized database. It allows for customizable badges
            creation using the inbuilt badge design templates. The kiosk mode
            enables unattended lobby visitors registration and badging, with
            options including pre-registration enforcement, robust barcode
            check-in/check-out functionality and support for barcode scanner.
          </p>
          <p>
            Additionally, the ability to create reports and run queries with the
            solution is simplified through the use of broad range of predefined
            crystal reports. Central administration of <span>iVisitNG</span>{" "}
            functions can be performed through direct access to the database,
            badge creation, real time monitoring and report creation.
          </p>
        </div>
        <div className="details-features">
          <p>
            <span>Features</span>
          </p>
          <p>
            The key features of <span>iVisitNG</span> are as follows:
          </p>
          <ol>
            <li>
              <p>
                Provide robust web based pre-registration by authorized
                employee;
              </p>
            </li>
            <li>
              <p>Provides access control to floors and offices;</p>
            </li>
            <li>
              <p>Support Individual and Group registration;</p>
            </li>
            <li>
              <p>
                Delivery of email/SMS confirmation to employee and visitor with
                registration number and barcode;
              </p>
            </li>
            <li>
              <p>
                Very fast fingerprint identification (10 000 templates {"<"} 1.5
                seconds);
              </p>
            </li>
            <li>
              <p>
                Enable returning visitor quick look up for pre-registration;
              </p>
            </li>
            <li>
              <p>
                Creates a chip based Visitor Card that can be swiped at a
                Magnetic Door Lock for authorized entry;
              </p>
            </li>
            <li>
              <p>Provide ability for host employee check out online;</p>
            </li>
            <li>
              <p>
                Support preconfigured appointment alerts for host employee or
                staff and visitor;
              </p>
            </li>
          </ol>
        </div>
        <p className="details-cta">Request for demo and proposal today…</p>
      </div>
      <Footer />
    </div>
  );
}

export default IVisitNg;
